/**
 * faang_engineering.js — Forge (Technical Specification)
 * ─────────────────────────────────────────────────────────────────────────────
 * Design Bible:
 *   Brand Name:   Forge
 *   Purpose:      Engineering Density & Technical Precision
 *   Reads Like:   Systems Design / API Documentation Spec
 *   Emotion:      Technical, Precise, Dense
 *   Personality:  Precise
 *   Reading Speed: Fast, scanning-first
 *   Scanning:     Top Left ↓ (horizontal search for technical keyword hits)
 *   Hero Moment:  Technical Skills API Block. Spanning the upper page, un-bulleted
 *                 dense monospace code-comment schema blocks.
 *   ATS Target:   High ATS Compatibility
 *
 * Forbidden Elements:
 *   ✗ Serif fonts
 *   ✗ Narrative summary blocks
 *   ✗ Big whitespace or editorial margins
 *   ✗ Executive banners or colored badge pills
 */

export const faang_engineering = {
  id: 'faang-engineering',
  version: 3,
  renderer: 'enterprise',
  name: 'Forge',
  layout: 'single-column',
  theme: 'classic-navy',
  density: 'compact',
  sectionDividerStyle: 'left-bar',
  // Narrative Shift: Skills and Projects (technical output) lead immediately before Experience
  sectionOrder: ['personal-info', 'skills', 'projects', 'experience', 'education', 'certifications'],
  components: {
    header: 'header-split',
    experience: 'experience-compact',
    projects: 'projects-list',
    skills: 'skills-categorized',
    education: 'education-classic',
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['skills', 'projects', 'experience', 'education', 'certifications'],
      },
      overrides: {
        '--font-family-primary': '"Inter", "Helvetica Neue", Arial, sans-serif',
        '--font-family-secondary': '"JetBrains Mono", "Fira Code", "Consolas", monospace',
        '--color-primary': '#0891B2', // Cyan
        '--color-secondary': '#1E293B', // Slate Dark
        '--color-accent': '#06B6D4', // Vibrant Cyan Accent
        '--color-text-main': '#0F172A',
        '--color-text-light': '#475569',
        '--color-border': '#E2E8F0',
        '--color-bg-page': '#FFFFFF',
        '--spacing-margin': '16px',
        '--spacing-section-mb': '10px',
        '--spacing-item-mb': '6px',
        '--spacing-bullet-gap': '2px',
      },
    },
  },
  styleOverrides: {
    '--font-size-display': '22pt',
    '--weight-display': '900',
    '--heading-weight': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.12em',
    '--border-thickness-heading': '0',
    '--bullet-style': 'disc',
    '--font-size-heading': '8.5pt',
    '--font-size-body': '9pt',
    '--font-size-bullet': '8.8pt',
    '--line-height-body': '1.35',
  },
};

export default faang_engineering;
